import { type SentryOptions } from './initSentry';

// @ai-generated 2026-10-29T11:47:13+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** The Sentry options a client configures through its `VITE_SENTRY_*` environment variables. */
export function sentryOptionsFromEnv(env: Record<string, string | undefined>, release: string): SentryOptions {
    return {
        enabled: env.VITE_SENTRY_ENABLED === 'true',
        dsn: env.VITE_SENTRY_DSN,
        sendDefaultPii: env.VITE_SENTRY_SEND_DEFAULT_PII === 'true',
        environment: env.VITE_SENTRY_ENVIRONMENT,
        debug: env.VITE_SENTRY_DEBUG === 'true',
        release,
        tracesSampleRate: parseFloat(env.VITE_SENTRY_TRACE_SAMPLE_RATE ?? ''),
    };
}
